import React from "react";
import {Container} from "@mantine/core";

export default function CreateVideo(){
    return(
        <Container fluid>

        </Container>
    )
}